import tippy from 'tippy.js';

export default function TooltipService(
    $window
) {
    'ngInject';

    Object.assign(this, {
        destroyTooltip,
        integrate,
        setTooltipHtml,
        showTooltip,
        hideTooltip,
    });

    function destroyTooltip(tooltipInstance) {
        if (!tooltipInstance) {
            return;
        }
        tooltipInstance.destroyAll();
    }

    function integrate(elementsSelector) {
        const seats = $window.document.querySelectorAll(elementsSelector);
        return tippy(seats, {
            trigger: 'manual',
            html: '#myTemplate',
            arrow: true,
            theme: 'light',
            animation: 'fade',
            distance: 15,
            arrowTransform: 'scale(2)',
        });
    }

    function setTooltipHtml(element, html) {
        if (!element._tippy) {
            return;
        }
        const tippyContent = element._tippy.popper.querySelector('.tippy-content');
        tippyContent.innerHTML = html;
    }

    function showTooltip(element) {
        if (!element._tippy) {
            return;
        }
        element._tippy.show();
    }

    function hideTooltip(element) {
        if (!element._tippy) {
            return;
        }
        element._tippy.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/services/tooltip-service.js